import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const cards = [
  {
    name: "Web Design",
    tagline: "Custom sites, no templates, built and managed for you",
    href: "/web-design.html",
    badge: "From $75/mo",
  },
  {
    name: "Design Services",
    tagline: "Logos, ad cards, social posts, anything visual",
    href: "/design.html",
    badge: "From $30",
  },
  {
    name: "Social Media",
    tagline: "Posts, replies, and ads, handled for you",
    href: "/social-media.html",
    badge: "From $400/mo",
  },
  {
    name: "Care Plans",
    tagline: "Hosting, security, and edits made for you",
    href: "/care-plans.html",
    badge: "From $5/mo",
  },
];

// children render between the headline and the service cards (the homepage
// puts the client showcase there).
const Hero = ({ children }: { children?: React.ReactNode }) => (
  <section className="relative min-h-[90vh] flex items-center justify-center">
    <div className="relative z-10 w-full min-w-0 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
      {/* The wordmark is the visual headline. The h1 stays as real, visible
          text (small, under the wordmark) so search engines still read it. */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="text-center mb-10"
      >
        <p className="text-6xl sm:text-7xl md:text-8xl font-bold tracking-tight leading-none mb-5">
          <span className="text-white">Rare</span>
          <span className="text-gradient">Works</span>
        </p>
        <h1 className="text-sm sm:text-base font-medium text-gray-300 mb-1">
          Web Design, Software &amp; Marketing for Small Businesses
        </h1>
        <p className="text-sm text-gray-400 max-w-2xl mx-auto">
          Based in Columbia, MS. Prices published, the same for every customer.
        </p>
      </motion.div>

      {children}

      {/* Service cards: one row of four on a wide screen, two rows of two below that */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {cards.map((card) => (
          <a
            key={card.name}
            href={card.href}
            className="group rounded-2xl glass p-4 hover:border-teal-500/50 transition-colors"
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <h3 className="text-base font-medium text-white">{card.name}</h3>
              <ArrowUpRight className="w-4 h-4 shrink-0 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
            <p className="text-sm text-gray-400 leading-snug sm:leading-5 mb-3">{card.tagline}</p>
            <span className="text-sm font-medium tabular-nums text-gray-200">{card.badge}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;
